const readableMonth = (date) => {
  const months = [
    "Januray",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
  return months[date.getMonth()]
}

const readableTime = (date) => {
  let hour = date.getHours()
  const minute = String(date.getMinutes()).padStart(2, "0")
  const ampm = (hour >= 12 ? "pm" : "am")
  if (hour > 12) {
    hour -= 12
  }
  else if (hour == 0) {
    hour = 12
  }
  return `${hour}:${minute} ${ampm}`
}

const readableWeekday = (date) => {
    switch (date.getDay()) {
      case 0:
        return "Sunday"
      case 1:
        return "Monday"
      case 2:
        return "Tuesday"
      case 3:
        return "Wednesday"
      case 4:
        return "Thursday"
      case 5:
        return "Friday"
      case 6:
        return "Saturday"
    }
}

const humanReadableDate = (date) => {
    const weekday = readableWeekday(date)
    const month = readableMonth(date)
    const monthday = date.getDate()
    return `${weekday} ${month} ${monthday}`
}

const readDateTime = (time) => {
  const date = new Date(time)
  return `${humanReadableDate(date)}, ${date.getFullYear()} at ${readableTime(date)}`
}

const sortTimes = (times) => {
  times.sort(function(a, b) {
    // Compare the 2 times
    if (a.dateTime < b.dateTime) return -1;
    if (a.dateTime > b.dateTime) return 1;
    return 0;
  });

  let sortedTimes = {}
  for (let i = 0; i < times.length; ++i) {
    let date = new Date(times[i].dateTime)
    let dateString = humanReadableDate(date)
    let timeString = readableTime(date)
    let timeObj = {
      timeString,
      dateTime: times[i].dateTime,
    }
    if (sortedTimes[dateString]) {
      sortedTimes[dateString].push(timeObj)
    }
    else {
      sortedTimes[dateString] = [timeObj]
    }
  }
  console.log(sortedTimes)
  return sortedTimes
  // return times
}
  
// export default sortTimes
exports.sortTimes = sortTimes
exports.readDateTime = readDateTime

// exports.schemaCheckouts = schemaCheckouts
  